import { Button, Checkbox, Label, Modal, ModalBody } from "flowbite-react";
import { useState } from "react";
import { useApplication } from "../../contexts/ApplicationContext";
import axiosInstance from "../../config/axiosInstance";
import { COMPANY } from "../../config/apiConfig";

export function ModalTerms() {
  const [openModal, setOpenModal] = useState(true);
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { refetchUser } = useApplication();

  const handleAcceptTerms = async () => {
    try {
      setLoading(true);
      await axiosInstance.post(COMPANY.ACCEPT_TERMS);
      await refetchUser();
      setOpenModal(false);
    } catch (error) {
      console.error("Erro ao aceitar termos:", error);
      alert("Erro ao salvar o aceite. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={openModal} onClose={() => setOpenModal(false)} size="4xl">
        <ModalBody>
          <div className="text-center mb-2 font-semibold uppercase">
            Termos de Uso
          </div>

          <div
            className="space-y-6 overflow-y-scroll bg-gray-100 p-4 rounded-md text-sm"
            style={{ maxHeight: "400px" }}
          >
            {/* ===================== CONTRATO PRINCIPAL ===================== */}
            <h1 className="underline text-center">
              CONTRATO DE PRESTAÇÃO DE SERVIÇOS
            </h1>

            <p>
              Pelo presente instrumento particular, CONTRATANTE e CONTRATADA,
              têm pactuado entre si o presente contrato, mediante as cláusulas e
              condições a seguir expostas:
            </p>

            <h2 className="underline">CLÁUSULA 1ª: DO OBJETO</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                O objeto do Contrato é a prestação de serviços de
                disponibilização pela CONTRATADA à CONTRATANTE de bancos de
                dados, informações de cadastros relativos aos consumidores
                (pessoas físicas ou jurídicas) em âmbito nacional, bem como
                serviço de proteção ao crédito e congêneres.
              </li>
              <li>
                A CONTRATANTE, através do meio de acesso retro descrito,
                realizará consultas às informações cadastrais disponíveis nos
                Bancos de Dados, acessadas diretamente ou através da CONTRATADA.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA 2ª: DA UTILIZAÇÃO DO SOFTWARE E OBRIGAÇÕES DOS
              CONTRATANTES
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                A CONTRATANTE passará a fazer parte do quadro de CLIENTES da
                CONTRATADA a partir da assinatura deste contrato, feita
                presencialmente e/ou eletronicamente, pressupondo leitura e
                aceite de todas as cláusulas.
              </li>
              <li>
                As consultas serão feitas no site da CONTRATADA com login e
                senha fornecidos.
              </li>
              <li>
                Consultas de CNPJ ou CPF, conforme o tipo da pessoa, e para
                cheques e veículos, deverá informar os dados necessários.
              </li>
              <li>
                A concessão de crédito ou decisões com base nas informações é de
                inteira responsabilidade da CONTRATANTE.
              </li>
              <li>
                A CONTRATANTE é responsável pela guarda e sigilo de suas senhas
                e deve comunicar qualquer uso indevido.
              </li>
              <li>
                O contrato permanece válido mesmo com mudanças administrativas
                na CONTRATANTE.
              </li>
              <li>
                A CONTRATADA pode alterar sites e fontes de dados sem aviso
                prévio.
              </li>
              <li>
                O uso de novos produtos ou funcionalidades implica adesão
                automática no primeiro uso.
              </li>
              <li>
                É responsabilidade da CONTRATANTE acompanhar as atualizações no
                site da CONTRATADA.
              </li>
              <li>
                É vedada a divulgação, revenda ou uso indevido das informações
                obtidas.
              </li>
              <li>
                As informações devem ser usadas exclusivamente para análise de
                crédito e negócios.
              </li>
              <li>
                A CONTRATADA não se responsabiliza por perdas ou danos causados
                pela interpretação das informações.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA 3ª: DOS VALORES, REAJUSTE E FORMA DE PAGAMENTO
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Faturamento mensal via fatura enviada para o e-mail da
                CONTRATANTE, conforme ANEXO I.
              </li>
              <li>
                Se o boleto não for recebido, a CONTRATANTE deve solicitá-lo à
                CONTRATADA.
              </li>
              <li>
                Pagamentos em atraso terão juros de 1% ao mês, correção pelo
                IGP-M e multa de 2%.
              </li>
              <li>
                Dados da CONTRATANTE poderão ser incluídos em cadastros de
                inadimplência.
              </li>
              <li>
                O sistema será bloqueado após 5 dias de atraso e reativado após
                regularização.
              </li>
              <li>
                O contrato continua gerando cobranças mesmo com o sistema
                bloqueado.
              </li>
              <li>
                A CONTRATADA pode rescindir o contrato em caso de inadimplência.
              </li>
            </ul>

            <h2 className="underline">CLÁUSULA 4ª: DO REAJUSTE</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Reajuste anual em junho com base no IGP-M ou outros índices
                permitidos por lei.
              </li>
              <li>
                A CONTRATANTE é responsável por todos os valores gerados por seu
                uso do sistema.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA 5ª: DO SIGILO, CONFIDENCIALIDADE E SEGURANÇA DAS
              INFORMAÇÕES
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Login e senha são pessoais, intransferíveis e considerados
                assinatura eletrônica.
              </li>
              <li>
                A CONTRATANTE deve manter o sigilo de seus acessos e proteger
                seu ambiente de rede.
              </li>
              <li>
                A CONTRATANTE confirma o recebimento da senha e treinamento no
                ato da contratação.
              </li>
              <li>
                É obrigatória a adoção de práticas de segurança como antivírus,
                firewall e antispyware.
              </li>
              <li>
                As partes se comprometem a cumprir a Lei 13.709/18 (LGPD).
              </li>
            </ul>

            <h2 className="underline">CLÁUSULA 6ª: DA VIGÊNCIA E RESCISÃO</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Contrato com vigência mínima de 12 meses e renovação automática.
              </li>
              <li>
                Para não renovação, é necessário aviso prévio de 30 dias antes
                do fim da vigência.
              </li>
              <li>
                Rescisão antecipada implica multa de 10% da franquia vezes os
                meses restantes.
              </li>
              <li>
                Não poderá haver pendências no momento da solicitação de
                rescisão.
              </li>
              <li>
                Consultas realizadas no mês da rescisão serão cobradas
                integralmente.
              </li>
              <li>
                A CONTRATANTE é responsável por excluir protestos registrados
                por ela.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA 7ª: DAS CONDIÇÕES GERAIS E FIANÇA
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                O signatário do contrato se torna fiador e responsável pelos
                compromissos assumidos.
              </li>
              <li>
                O fiador renuncia a benefícios legais de ordem e pode ter seus
                dados negativados.
              </li>
            </ul>

            <h2 className="underline">CLÁUSULA 8ª: DO FORO</h2>
            <p>
              Fica eleito o Foro da Comarca de São Paulo - SP para resolver
              quaisquer controvérsias.
            </p>

            <p>
              E por estarem assim justos e contratados, conhecedores de todas as
              cláusulas do presente contrato, aceitando as condições
              estipuladas, assinam o presente contrato, sem quaisquer restrições
              ou dúvidas, em duas vias na presença de duas testemunhas.
            </p>

            <p>
              São Paulo,{" "}
              {new Date().toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
              .
            </p>

            {/* ===================== TERMO ADITIVO: NEGATIVAÇÃO ===================== */}
            <hr className="my-6" />
            <h1 className="underline text-center">
              TERMO ADITIVO À ESPECIFICAÇÃO DE SERVIÇO – NEGATIVAÇÃO
            </h1>
            <p className="text-center italic">
              Termo Aditivo nº ___/2025 — Parte integrante e indissociável do
              Contrato Master de Prestação de Serviços.
            </p>

            <h2 className="underline">CLÁUSULA PRIMEIRA – OBJETO</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Estabelecer as condições aplicáveis ao serviço de inclusão de
                registros no banco de dados de devedores inadimplentes
                (“Negativação”) no SCPC da CONTRATADA.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA SEGUNDA – CONDIÇÕES COMERCIAIS
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                A cada Negativação, a CONTRATADA enviará ao devedor o
                <strong> Comunicado de Aviso de Débito</strong> (CDC, art. 43,
                §2º); despesas destes envios (carta, meios eletrônicos etc.) são
                de responsabilidade do CLIENTE.
              </li>
              <li>
                Reajuste automático anual pelos últimos 12 meses do{" "}
                <strong>IPCA</strong> (ou índice que o substitua).
              </li>
              <li>
                Serviços dos Correios: sujeitos a repasses/reajustes de tarifas
                e a todos os custos de envio dos comunicados.
              </li>
              <li>
                Valores podem ser acrescidos por variações de custos/tributos;
                faturamento e cobrança conforme Contrato/Ordem de Serviço.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA TERCEIRA – CONDIÇÕES GERAIS DO SERVIÇO DE NEGATIVAÇÃO
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                O CLIENTE deve informar dados completos e corretos do devedor
                (endereços físicos, eletrônicos e celular). CEP genérico pode
                gerar custos adicionais.
              </li>
              <li>
                Texto dos Comunicados pode ser alterado pela CONTRATADA; há
                campo opcional de até 300 caracteres para mensagem do CLIENTE
                (exceto SMS), mediante aprovação.
              </li>
              <li>
                Pode-se incluir boleto no comunicado (Carta ou E-mail).
                Processamento dos arquivos ocorre até o dia seguinte ao envio;
                disparos no dia seguinte ao processamento, conforme sequência
                definida.
              </li>
              <li>
                Se avisos eletrônicos falharem, envia-se Carta (cobrando apenas
                a Carta). Se um eletrônico tiver sucesso, não há Carta e
                cobra-se o eletrônico enviado.
              </li>
              <li>
                Inadimplemento: atraso em operações comprováveis (contratos,
                duplicatas, cheques, etc.). Registro de cheque sem fundos apenas
                nos motivos 12, 13 ou 14.
              </li>
              <li>
                Exclusão do registro poderá ocorrer por iniciativa do CLIENTE,
                falência/extinção, encerramento do Contrato, reclamações
                reiteradas sem comprovação, regularização, litígio com garantia
                do Juízo/ordem judicial, ou risco à base de dados.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA QUARTA – CONDIÇÕES ESPECÍFICAS DO AVISO ELETRÔNICO DE
              DÉBITO
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Disponível em <strong>E-mail</strong> e <strong>SMS</strong>;
                novas tecnologias poderão ser adotadas automaticamente, com
                comunicação ao CLIENTE e preço conforme tabela vigente.
              </li>
              <li>
                Endereços podem ser da base da CONTRATADA ou do CLIENTE (em PJ,
                utiliza-se os do CLIENTE; podem ser usados e-mails/telefones de
                sócios).
              </li>
              <li>
                Cada Parte mantém a outra indene por reclamações relativas aos
                endereços utilizados segundo a opção escolhida.
              </li>
            </ul>

            <h2 className="underline">
              CLÁUSULA QUINTA – INFORMAÇÕES PARA CONTATO DO CONSUMIDOR
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Os Comunicados conterão informações do CLIENTE para contato e
                regularização; o CLIENTE deve mantê-las atualizadas junto à
                CONTRATADA.
              </li>
            </ul>

            <h2 className="underline">CLÁUSULA SEXTA – DISPOSIÇÕES GERAIS</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                O CLIENTE assume responsabilidade por inclusões/baixas conforme
                lei/Contrato, mantendo documentos que comprovem a dívida por{" "}
                <strong>5 anos</strong> (envio em até
                <strong> 72 horas</strong> quando solicitado, sob pena de baixa
                da negativação).
              </li>
              <li>
                Inclusões/baixas apenas via sistema; não são aceitas por e-mail.
              </li>
              <li>
                A CONTRATADA não altera/suprime dados após inclusão (salvo ordem
                judicial/ administrativa), preservando o Histórico conforme
                legislação.
              </li>
              <li>
                Acesso pago ao <strong>Histórico</strong> (últimos 5 anos)
                somente para defesa em demandas judiciais relativas às negativ
                ações do próprio CLIENTE; uso fora desse escopo é vedado e pode
                gerar bloqueio, sanções e medidas judiciais.
              </li>
              <li>
                Demais disposições do Contrato permanecem válidas; antes de
                medida judicial, as partes tentarão conciliação em até{" "}
                <strong>10 dias</strong>.
              </li>
            </ul>
          </div>

          <div className="flex items-center gap-2 mt-4">
            <Checkbox
              id="accept"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
            <Label htmlFor="accept" className="flex">
              Li e aceito os termos de uso e o termo aditivo de negativação
            </Label>
          </div>

          <div className="flex justify-center items-center w-full mt-4">
            <Button
              className="py-2 px-4 w-fit"
              onClick={handleAcceptTerms}
              disabled={!accepted || loading}
              isProcessing={loading}
            >
              Continuar
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
